import api from "../../../components/axiosComp";
import axios from "axios";

// PRESIGN for S3 direct upload (backend call)
export const presignUpload = async ({ folder, filename, contentType }) => {
  const { data } = await api.post("/api/uploads/presign", {
    folder,
    filename,
    contentType,
  });
  // returns: { uploadUrl, filePath }
  return data;
};

// DIRECT UPLOAD TO S3 (PUT) (⚠️ must NOT use `api`)
export const uploadFileToS3 = async ({ presign, file, onProgress }) => {
  if (!presign?.uploadUrl && !presign?.url) {
    throw new Error("Missing presign data (uploadUrl/url). Did you pass `presign`?");
  }

  const resp = await axios.put(presign.url || presign.uploadUrl, file, {
    headers: {
      "Content-Type": file.type || "application/octet-stream",
    },
    onUploadProgress: (evt) => {
      if (onProgress && evt.total) {
        onProgress(Math.round((evt.loaded / evt.total) * 100));
      }
    },
  });

  if (![200, 201, 204].includes(resp?.status)) {
    throw new Error(`S3 upload failed`);
  }

  return {
    key: presign.key || presign.filePath,
    publicUrl: presign.publicUrl,
  };
};


// LIST
export const listBanners = async ({ country, includeInactive } = {}) => {
  const params = {};
  if (country) params.country = country;
  if (typeof includeInactive === "boolean") {
    params.includeInactive = includeInactive ? "true" : "false";
  }

  const { data } = await api.get("/api/superAdmin/banners", { params });
  return Array.isArray(data) ? data : [];
};

// CREATE
export const createBanner = async (payload) => {
  const { data } = await api.post("/api/superAdmin/banners", payload);
  return data;
};

// UPDATE
export const updateBanner = async (id, payload) => {
  const { data } = await api.put(`/api/superAdmin/banners/${id}`, payload);
  return data;
};

// DELETE
export const deleteBanner = async (id) => {
  const { data } = await api.delete(`/api/superAdmin/banners/${id}`);
  return data;
};
